import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DashboardState {
  isLoading: boolean;
  error: string | null;
  dataLoaded: boolean;
  lastSyncDate: string | null;
  chartData: {
    monthlyOrders: number[];
    totalOrders: number;
    pendingOrders: number;
    syncedOrders: number;
  };
}

const initialState: DashboardState = {
  isLoading: false,
  error: null,
  dataLoaded: false,
  lastSyncDate: null,
  chartData: {
    monthlyOrders: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    totalOrders: 0,
    pendingOrders: 0,
    syncedOrders: 0,
  },
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    dashboardLoadStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    dashboardLoadSuccess(state) {
      state.isLoading = false;
      state.error = null;
      state.dataLoaded = true;
      state.lastSyncDate = new Date().toISOString();
    },
    dashboardLoadError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
      state.dataLoaded = false;
    },
    clearDashboardError(state) {
      state.error = null;
    },
    resetDashboardState(state) {
      state.isLoading = false;
      state.error = null;
      state.dataLoaded = false;
      state.lastSyncDate = null;
      state.chartData = initialState.chartData;
    },
    updateChartData(
      state,
      action: PayloadAction<{
        monthlyOrders?: number[];
        totalOrders?: number;
        pendingOrders?: number;
        syncedOrders?: number;
      }>
    ) {
      if (action.payload.monthlyOrders) {
        state.chartData.monthlyOrders = action.payload.monthlyOrders;
      }
      if (action.payload.totalOrders !== undefined) {
        state.chartData.totalOrders = action.payload.totalOrders;
      }
      if (action.payload.pendingOrders !== undefined) {
        state.chartData.pendingOrders = action.payload.pendingOrders;
      }
      if (action.payload.syncedOrders !== undefined) {
        state.chartData.syncedOrders = action.payload.syncedOrders;
      }
    },
  },
});

export const {
  dashboardLoadStart,
  dashboardLoadSuccess,
  dashboardLoadError,
  clearDashboardError,
  resetDashboardState,
  updateChartData,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
